import { createFileRoute } from "@tanstack/react-router";
import { ScopesPage } from "../features/scopes/scopes-page";

export const Route = createFileRoute("/_app/w/$workspace/scopes")({ component: ScopesPage });
